import { Wishlist } from 'types/entity/wishlist';
import { resolveFacetKeyMatches } from 'helpers/utils/attributes';
import { GroupedAttribute, Term } from '..';
import { FacetConfiguration } from '../../../types';

type Facet = {
  facetLabel: string;
  facetKey: string;
};
type FacetList = Facet[];

const makeFacetObject = (attributes: any, data: Record<string, FacetConfiguration>, wishlist?: Wishlist) => {
  return [
    ...attributes
      .filter((prefix: any) => prefix.facetKey !== 'favorite')
      .map((prefix: any) => {
        const grouped: GroupedAttribute = {
          type: 'term',
          identifier: prefix?.facetLabel,
          label: prefix?.facetLabel,
          key: prefix?.facetKey,
          selected: false,
          terms: [],
        };

        const facetKeys = prefix?.facetKey?.split(',').map((k: string) => k.trim()) || [];
        const dataKeys = Object.keys(data);
        const matchedKeys = new Set<string>(
          facetKeys.flatMap((facetKey: string) => resolveFacetKeyMatches(dataKeys, facetKey)),
        );

        for (const key of matchedKeys) {
          const terms = (data[key] as any).terms || [];
          const enrichedTerms: Term[] = terms
            .filter(
              (term: any) =>
                (term.identifier as string).toLowerCase() !== 'none' &&
                (term.label as string).toLowerCase() !== 'none',
            )
            .map((term: any) => ({
              ...term,
              sourceIdentifier: key,
            }));

          grouped.terms.push(...enrichedTerms);
        }

        return grouped;
      }),
    ...(wishlist?.lineItems?.length && wishlist?.lineItems?.length > 0
      ? attributes
          .filter((prefix: any) => prefix.facetKey === 'favorite')
          .map((prefix: any) => {
            const grouped: GroupedAttribute = {
              type: 'term',
              identifier: prefix?.facetKey,
              label: prefix?.facetLabel,
              key: prefix?.facetKey,
              selected: false,
              terms: [
                {
                  identifier: prefix?.facetKey,
                  label: prefix?.facetLabel,
                  count: 0,
                  key: prefix?.facetKey,
                  sourceIdentifier: prefix?.facetKey,
                },
              ],
            };

            return grouped;
          })
      : []),
  ];
};

export function groupVariantsByAttributes(
  data: Record<string, FacetConfiguration>,
  universalAttributePrefixes: FacetList,
  categoryAttributePrefixes: FacetList,
  wishlist?: Wishlist,
  isSearchPage: boolean = true,
): GroupedAttribute[] {
  if (!universalAttributePrefixes || universalAttributePrefixes.length === 0 || !data) {
    return [];
  }
  const universalFilters = makeFacetObject(universalAttributePrefixes, data, wishlist);
  let showAllCategoryAttributes = false;
  if (
    universalFilters[0].key === 'categories' &&
    (universalFilters[0].terms.some((t: any) => t.selected) || universalFilters[0].terms.length === 1)
  ) {
    showAllCategoryAttributes = true;
  }
  if (showAllCategoryAttributes || !isSearchPage) {
    return [...makeFacetObject(categoryAttributePrefixes, data), ...universalFilters];
  } else {
    return [...universalFilters];
  }
}
